import { useEffect, useState, type CSSProperties } from "react";
import { playSound } from "../lib/sound.ts";

export type ResultOutcome = "win" | "loss" | "draw";
const played = new Set<string>();

export function ResultEffects({ matchId, outcome }: { matchId: string; outcome: ResultOutcome }) {
  const [animationMatchId, setAnimationMatchId] = useState<string | null>(() => played.has(matchId) ? null : matchId);
  useEffect(() => {
    if (played.has(matchId)) return;
    played.add(matchId);
    setAnimationMatchId(matchId);
    if (document.visibilityState === "visible") playSound(`result-${outcome}`);
  }, [matchId, outcome]);

  if (animationMatchId !== matchId) return null;
  return <div className="result-effects" data-outcome={outcome} aria-hidden="true">
    {outcome === "win" && Array.from({ length: 16 }, (_, index) => {
      const angle = index * 137.5 * Math.PI / 180;
      const style = {
        "--particle-x": `${Math.round(Math.cos(angle) * (65 + index * 11))}px`,
        "--particle-y": `${Math.round(Math.sin(angle) * (65 + index * 11))}px`,
        "--particle-delay": `${(index % 5) * 45}ms`,
      } as CSSProperties;
      return <i key={index} style={style} />;
    })}
  </div>;
}
